<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="yrd-lcl-sort-pagination" *ngIf="stationDetailArr && stationDetailArr.length > 0">
    <span class="sorting">
    {{configData?.yardLocalLabel.sortBy}}
  <button type="button" tabindex="{{tabLevel}}" [ngClass]="(selectedSortBy === 'alphabeticByDivision')? 'p-button-primary' : 'p-button-secondary'" (click)="sortByData('alphabeticByDivision')">
    {{configData?.yardLocalLabel.alphabeticByDivision}} 
    <span *ngIf="selectedSortBy === 'alphabeticByDivision'" [ngClass]="(selectedAlphaSortType === 'asc')?'asc':'desc'"></span>
    </button>

    <button type="button" tabindex="{{tabLevel + 2}}" [ngClass]="(selectedSortBy === 'netAllocation')? 'p-button-primary ml-3' : 'p-button-secondary ml-3'" (click)="sortByData('netAllocation')">
      {{configData?.yardLocalLabel.netAllocation}}
      <span *ngIf="selectedSortBy === 'netAllocation'" [ngClass]="(selectedNetAllocSortType === 'asc')?'asc':'desc'"></span>
  </button>

    <button type="button" tabindex="{{tabLevel + 4}}" [ngClass]="(selectedSortBy === 'extraPower')? 'p-button-primary ml-3' : 'p-button-secondary ml-3'" (click)="sortByData('extraPower')">
     {{configData?.yardLocalLabel.extraPower}}
     <span *ngIf="selectedSortBy === 'extraPower'" [ngClass]="(selectedExtraPowerSortType === 'asc')?'asc':'desc'"></span>
  </button>
    </span>
</div>
<div *ngIf="showHeader && !yardLocalDetail?.isLoaded">
    {{configData?.messages.terminalStatusDefaultView}}
</div>
<div *ngIf="showHeader && yardLocalDetail?.isLoaded && stationDetailArr && stationDetailArr.length === 0">
    {{configData?.messages.noRecordFound}}
</div>